import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { CustomCard } from "../../../components/Card/CustomCard";
import {CantAsientosRechazados} from "../../../funciones/EstCuentaFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import ModalReports from '../../../components/Reportes/ModalReports';
import PagosNoAp from '../../../components/Reportes/PagosNoAp';

const PagosRechazados = (props) => {
    const [tipoIngreso, setTipoIngreso] = useState({ value: '', label: '- Selecciona un Tipo -' });
    const [mesSelect, setMesSelect] = useState({ value: "01", label: '- Enero -' });
    const [transacciones, setTransacciones] = useState(<React.Fragment><i className = "fa fa-spin fa-spinner"></i> Buscando</React.Fragment>);
    const [asientos, setAsientos] = useState([]);
    const [loader, setLoader] = useState({ icon: "", text: "Selecciona un Tipo de Consulta" });
    const [openWR, setOpenWR] = useState(false);

    let valorTipo = (tipoIngreso) => {
        setTipoIngreso(tipoIngreso)

        setTransacciones(<React.Fragment><i className = "fa fa-spin fa-spinner"></i> Buscando</React.Fragment>)
        setLoader ({ icon: "fa fa-spinner fa-spin", text: "Buscando Asientos Rechazados" })
        CantAsientosRechazados (tipoIngreso.value, mesSelect.value, (resp) => {
            let text = ""
            if (resp[0].length === 0) text = "No existen trancciones rechazadas para la fecha indicada"
            setAsientos(resp[0]);
            setLoader ({ icon: "", text: text })
            setTransacciones(resp[0].length)
        })
    }

    let cambiaMes = (mesSelect) => {
        setMesSelect(mesSelect)

        setTransacciones(<React.Fragment><i className = "fa fa-spin fa-spinner"></i> Buscando</React.Fragment>)
        setLoader ({ icon: "fa fa-spinner fa-spin", text: "Buscando Asientos Rechazados" })
        setTipoIngreso(tipoIngreso)
        CantAsientosRechazados (tipoIngreso.value, mesSelect.value, (resp) => {
            let text = ""
            if (resp[0].length === 0) text = "No existen trancciones rechazadas para la fecha indicada"
            setAsientos(resp[0]);
            setLoader ({ icon: "", text: text })
            setTransacciones(resp[0].length)
        })
    }

    let modalReporte = () => {
        if (openWR === false ) return null

        if (asientos.length === 0) {
            toast.error("No hay ninguna transacción rechazada en la fecha seleccionada",{autoClose: 4000});
            return null
        }
        return (
            <ModalReports
                reporte={<PagosNoAp data = {asientos} title = {`Pagos ${tipoIngreso.label}`} tipo = {tipoIngreso.value} mes = {mesSelect.value}/>}
                titulo={`Pagos ${tipoIngreso.label}`}
                display= "block"
                cerrar = {() => {setOpenWR(false)}}
            />
        )
    }

    const meses = [
        { value: "01", label: '- Enero -' },
        { value: "02", label: '- Febrero -' },
        { value: "03", label: '- Marzo -' },
        { value: "04", label: '- Abril -' },
        { value: "05", label: '- Mayo -' },
        { value: "06", label: '- Junio -' },
        { value: "07", label: '- Julio -' },
        { value: "08", label: '- Agosto -' },
        { value: "09", label: '- Septiembre -' },
        { value: "10", label: '- Octubre -' },
        { value: "11", label: '- Noviembre -' },
        { value: "12", label: '- Diciembre -' },
    ];

    const customStyles = {
        menu: (provided) => ({
          ...provided,
          zIndex: 10,
        })
    }

    let contentType = () => {
        switch (tipoIngreso.value){
            case "dia": return (
                <div className = "custom-alert-danger">
                    <Row>
                        <Col md = {8} style={{marginTop: 10, paddingLeft: 20}}>
                            Total de Transacciones del día: {transacciones}
                        </Col>
                        <Col md = {4} align="right">
                            <button onClick={()=> {setOpenWR(true)}} title="Imprimir el listado de las transacciones rechazadas" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                        </Col>
                    </Row>
                </div>
            )
            case "mes": return (
                <div className = "custom-alert-danger">
                    <Row>
                        <Col md={3}>
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={mesSelect}
                                onChange={cambiaMes}
                                options={meses}
                            />
                        </Col>
                        <Col md={6} style={{marginTop: 10, paddingLeft: 20, fontSize: 11}}>
                            Transacciones del mes de {(mesSelect.label).replace(/-/g, '')}: {transacciones}
                        </Col> 
                        <Col md = {3} align="right">
                            <button onClick={()=> {setOpenWR(true)}} title="Imprimir el listado de las transacciones rechazadas" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                        </Col>
                    </Row>
                </div>
            )

            default: return null;
        }
    }

    let contenido = () => {
        const Opciones = [
            { value: 'dia', label: 'Rechazados del Dia' },
            { value: 'mes', label: 'Rechazados del Mes' },
        ];

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        const styles2 = {
            padding: 5, fontSize: 11
        }

        let notNull = (data) => {
            if (data === null) return "";
            return data;
        }

        let contentAsientos = () => {
            if (asientos.length === 0) return (
                <tr>
                    <td colSpan={5} align="center"><i className = {loader.icon}></i> {loader.text}</td>
                </tr>
            )

            return (
                asientos.map(option => (
                    <tr key = {option.id}>
                        <td align = "center" style={styles2}><strong>{option.idTrans}</strong></td>
                        <td style={styles2}>{option.fecha}</td>
                        <td style={styles2}>
                            <div><strong className = "text-danger">{`${option.nacionalidad}${option.ci}`}</strong></div>
                            <div>{option.nombre_1} {notNull(option.nombre_2)} {option.apellido_1} {notNull(option.apellido_2)}</div>
                        </td>
                        <td style={styles2}>
                            {/* <div><strong>Facturado:</strong> {formatNumber(option.debe)} Bs. | {formatReconver(option.debe)} Bs.</div>
                            <div><strong>Pagado:</strong> {formatNumber(option.haber)} Bs. | {formatReconver(option.debe)} Bs.</div> */}
                            <div><strong>Facturado:</strong> {formatNumber(option.debe)} Bs.</div>
                            <div><strong>Pagado:</strong> {formatNumber(option.haber)} Bs.</div>
                        </td>
                        <td style={styles2}>{option.status}</td>
                    </tr>
                ))
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={7} style={{marginTop: 10, paddingLeft: 20}}>
                            Tipo de Consulta
                        </Col>
                        <Col md ={5}>
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={tipoIngreso}
                                onChange={valorTipo}
                                options={Opciones}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="custom-mt-10">{contentType()}</div>
                <div className="table-responsive custom-mt-10" style={{backgroundColor: "#FFF", border:"1px solid #1f2f6e"}}>
                    <Table striped hover style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                <td width="10%" style={styles}><strong>Fecha</strong></td>
                                <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                <td width="25%" style={stylesBs}><strong>Detalles</strong></td>
                                <td width="15%" style={stylesBs}><strong>Motivo</strong></td>
                            </tr>
                            {contentAsientos()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

    }

    let ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes observar el listado de transacciones rechazadas. Seleccionando primero el <strong>Tipo de Consulta</strong>
            </Col>

        </Row>
    )
    
    return (
        <div className="content">
            <Row>
                <Col md={8}>
                    {contenido()}
                </Col>
                <Col md={4}>
                    <div style={{borderRadius: "4px 4px",}}>
                        <CustomCard
                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                            category={<span style={{color: "#fff"}}>Pagos Rechazados</span>}
                            color="#a80012"
                            content={ayuda()}
                        />
                    </div>
                </Col>
            </Row>
            {modalReporte()}
        </div>
    )
}

export default PagosRechazados;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/PagosRechazados.jsx